module.exports = __webpack_public_path__ + "img/lander-action-03-mobile.d87630d3.webp";